import React, { useEffect } from "react";
import { Input, Form, Button, message, Modal, Row, Col } from "antd";
import styles from "../management.module.scss";
import { useTranslation } from "react-i18next";
import { CharacterVerify } from "../../../Utility/RegExp";
import { custInfRecordProps } from "../index";
import { useEditCustomerInf } from "../queries";

interface schemeProps {
  EditCustomerInfovisible: boolean;
  setEditCustomerInfovisible: (arg: boolean) => void;
  record: custInfRecordProps;
  setRecord: (arg: custInfRecordProps | any) => void;
}

const EditCustomerInfoF = React.memo(
  ({ EditCustomerInfovisible, setEditCustomerInfovisible, record, setRecord }: schemeProps) => {
    const [form] = Form.useForm();
    const { t } = useTranslation();
    const { mutateAsync: editCustomerInfMutation, isLoading: editCustomerInfLoading } = useEditCustomerInf();

    useEffect(() => {
      if (record.inf_list) {
        form.setFieldsValue({
          company: record.inf_list.company,
          contact: record.inf_list.contact,
          mail: record.inf_list.mail,
          phone: record.inf_list.phone,
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [record.inf_list]);

    const editCustomerInf = (values: any) => {
      editCustomerInfMutation({ values, cid: record.cid })
        .then(() => {
          message.success(t("ISMS.Success"));
        })
        .catch(() => {
          message.error(t("ISMS.Fail"));
        });
    };

    return (
      <Modal
        title={t("ISMS.EditCustomerInfo")}
        visible={EditCustomerInfovisible}
        onCancel={() => {
          setEditCustomerInfovisible(false);
          setRecord({ inf_list: {} });
        }}
        footer={[
          <Button
            key="submit"
            type="primary"
            loading={editCustomerInfLoading}
            onClick={() => {
              form.submit();
            }}
          >
            {t("ISMS.Submit")}
          </Button>,
        ]}
      >
        {/* ManageMent => Create Custommer (已存在的Customer 修改資料Edit Information)*/}
        <Form name="Edit Info" onFinish={editCustomerInf} form={form} layout="vertical">
          <div className="formwrap">
            <Row gutter={24} justify="center">
              <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                <Form.Item
                  name={"company"}
                  label={t("ISMS.Company")}
                  // required (必填欄位): true 為必填
                  // message  (錯誤資訊，不填入則自動在該欄位下跳出警告): " 錯誤資訊! "
                  rules={[{ required: true, message: "required!" }, CharacterVerify]}
                >
                  <Input placeholder={t("ISMS.CompanyName")} maxLength={30} />
                </Form.Item>
                <Form.Item name={"contact"} label={t("ISMS.ContactPerson")} rules={[CharacterVerify]}>
                  <Input placeholder={t("ISMS.Person Name")} maxLength={30} />
                </Form.Item>
                <Form.Item name={"mail"} rules={[{ type: "email", message: "Invalid!!" }]} label={t("ISMS.Email")}>
                  <Input placeholder={t("ISMS.MailAddress")} maxLength={30} />
                </Form.Item>
                <Form.Item
                  rules={[{ type: "string", message: "Invalid!!", pattern: /^\d+$/ }]}
                  name={"phone"}
                  label={t("ISMS.Phone")}
                >
                  <Input placeholder={t("ISMS.Phone Number")} maxLength={30} />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
      </Modal>
    );
  }
);

export default EditCustomerInfoF;
